import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { z } from 'zod';
import { BlockCard } from '../lib/block-card.js';
import { InlineMarkdown } from '../lib/inline-markdown.js';
export const TablePropsSchema = z
    .object({
    title: z.string().optional(),
    columns: z.array(z.string()),
    rows: z.array(z.array(z.string())),
})
    .strict();
/** Renders a `table` block. */
export function TablePrimitive({ title, columns, rows }) {
    return (_jsx(BlockCard, { title: title, children: _jsx("div", { className: "overflow-x-auto", children: _jsxs("table", { className: "w-full border-collapse text-left text-sm [&_tr:last-child_td]:border-0", children: [_jsx("thead", { children: _jsx("tr", { children: columns.map((column, index) => (_jsx("th", { className: "border-b border-border px-3 py-2 text-xs font-medium uppercase tracking-wider text-muted-foreground", children: column }, index))) }) }), _jsx("tbody", { children: rows.map((row, rowIndex) => (_jsx("tr", { children: row.map((cell, cellIndex) => (_jsx("td", { className: "border-b border-border/50 px-3 py-2 text-sm text-foreground/90", children: _jsx(InlineMarkdown, { children: cell }) }, cellIndex))) }, rowIndex))) })] }) }) }));
}
